import { Box } from '@mui/material';
import { Tooltip } from '@x5-react-uikit/core';
import { Warning as WarningIcon } from '@x5-react-uikit/icons';

const STATUS = {
  clientList: {
    DEFAULT: '',
    ERROR: 'Произошла непредвиденная ошибка',
  },
};

type Props = {
  scope?: 'clientList' | 'raw';
  status?: string;
};

const WarningStatus: React.FC<Props> = ({
  status = 'DEFAULT',
  scope = 'clientList',
}) => {
  if (!STATUS[scope]?.[status] && scope !== 'raw') return null;
  if (!status) return null;

  const content = STATUS?.[scope]?.[status] || status;

  return (
    <Tooltip placement="top" content={content}>
      <Box maxWidth="max-content" color="yellow.90">
        <WarningIcon color="currentColor" />
      </Box>
    </Tooltip>
  );
};

export default WarningStatus;
